import { render, staticRenderFns } from "./ModalInquiryConflict.vue?vue&type=template&id=b6750d08&"
import script from "./ModalInquiryConflict.vue?vue&type=script&lang=js&"
export * from "./ModalInquiryConflict.vue?vue&type=script&lang=js&"
import style0 from "./ModalInquiryConflict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports